gsap.set('.co-contact-s4-media img', {scale: 1.5});
gsap.to('.co-contact-s4-media img', {
    scrollTrigger: {
        trigger: '.co-contact-s4-media',
        toggleActions: "restart none none reverse",
        // markers: true,
        start: 'top 50%',
        end: 'bottom 50%',
        scrub: true,
        duration: 1
    },
    scale: 1,
});

// let timelines4 = gsap.timeline();
// gsap.set('.co-contact-s4-media img', {scale: 1});
// timeline.to('.co-contact-s4-media img', {
//     duration: 1,
//     scale: 1.1,
//     ease: "power2.out",
// });
// ScrollTrigger.create({
//     trigger: '.co-contact-s4-media',
//     start: "top bottom",
//     end: "bottom bottom",
//     toggleActions: "play none none none",
//     // toggleActions: "restart none none reverse",
//     animation: timelines4
// });